module.exports = __webpack_public_path__ + "img/jala-harvest-staging.b99274da.png";